import React from 'react';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import Input from '@lib/components/Input/Input';
import { InputTypes } from '@lib/components/Input/enums';
import { ComponentProps, defaultProps } from '../types';

export default function TextAreaPreview({ t }: ComponentProps) {
  return (
    <Input
      type={InputTypes.textarea}
      label={t('multi-line-value')}
      name={`${FormTemplateQuestionFieldsKindEnum.Input}-preview`}
      {...defaultProps}
    />
  );
}
